import { Redirect } from 'react-router-dom';
import { Route, Switch } from 'react-router';
import InvoiceDetail from './detail';
import InvoiceDraft from './draft';
import InvoiceExports from './exports';
import InvoiceExportsDetail from './exports-detail';
import InvoiceExportsEdit from './exports-edit';
import InvoiceReview from './review';
import InvoiceSummary from './summary';

const Invoice = () => {
    return (
        <Switch>
            <Route exact path='/accounting/invoice/review' component={InvoiceReview} />
            <Route exact path='/accounting/invoice/draft' component={InvoiceDraft} />
            <Route exact path='/accounting/invoice/detail' component={InvoiceDetail} />
            <Route exact path='/accounting/invoice/summary' component={InvoiceSummary} />
            <Route exact path='/accounting/invoice/exports' component={InvoiceExports} />
            <Route exact path='/accounting/invoice/exports/detail' component={InvoiceExportsDetail} />
            <Route exact path='/accounting/invoice/exports/edit' component={InvoiceExportsEdit} />
            <Redirect to='/accounting/invoice/review' />
        </Switch>
    );
};

export default Invoice;
